<template>
    <div class="section-selector">
        <label class="label">{{ label }}</label>
        <div class="closing-modal" @click="closeBody" v-if="bodyOpened"></div>
        <div class="input-row" :class="{ '-body-opened': bodyOpened }">
            <div
                class="opener"
                v-if="!bodyOpened"
                @click="openBody($event)"
            ></div>
            <div class="time-input">
                <input
                    :disabled="!bodyOpened"
                    ref="hours"
                    :placeholder="'HH'"
                    :maxlength="2"
                    :readonly="shouldDisableInput"
                    :value="inputHours"
                    @focus="
                        displaySave()
                        editingMinutes = true
                    "
                    @input="onHours"
                    @click="
                        selectValue('hours')
                        openBody($event)
                    "
                    @keydown.enter="closeBody()"
                />
            </div>
            <div>:</div>
            <div class="time-input">
                <input
                    ref="minutes"
                    :disabled="!bodyOpened"
                    :placeholder="'MM'"
                    :maxlength="2"
                    :readonly="shouldDisableInput"
                    :value="inputMinutes"
                    @focus="
                        displaySave()
                        editingHours = true
                    "
                    @input="onMinutes"
                    @click="
                        selectValue('minutes')
                        openBody($event)
                    "
                    @keydown.enter="closeBody()"
                />
            </div>
        </div>
        <transition name="fade">
            <div
                :style="{ top: top, left: left }"
                v-if="bodyOpened"
                class="menu-body"
                ref="menu"
                tabindex="-1"
                :class="{ '-bigger-text': shouldDisableInput }"
            >
                <div class="hours-list">
                    <div
                        class="menu-row"
                        :class="[
                            { '-selected': hour.value == value },
                            { '-bigger-text': shouldDisableInput }
                        ]"
                        ref="hourRow"
                        v-for="hour in availableHours"
                        :key="hour.value"
                        @click="setValue(hour.value)"
                    >
                        {{ hour.display }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'TimePicker',
    props: {
        label: String,
        value: Number,
        background: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            inputHours: '',
            inputMinutes: '',
            shouldDisplaySave: false,
            bodyOpened: false,
            top: '0px',
            left: '0px',
            editingMinutes: false,
            editingHours: false,
            convertedValue: 0,
            oldInputHours: '',
            oldInputMinutes: ''
        }
    },
    computed: {
        shouldDisableInput() {
            return (
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i)
            )
        },
        availableHours() {
            let hours = []
            let value = 0
            while (value <= 1420) {
                hours.push({
                    display: `${this.$Utils.displayHour(value)}:${this.$Utils.displayMinutes(value)}`,
                    value: value
                })
                value = value + 30
            }

            return hours
        }
    },
    methods: {
        displaySave() {
            if (this.shouldDisableInput) {
                return
            } else {
                this.shouldDisplaySave = true
            }
        },
        closeBody() {
            this.$nextTick(() => {
                this.bodyOpened = false
                if (
                    this.oldInputHours != this.inputHours ||
                    this.oldInputMinutes != this.inputMinutes
                ) {
                    this.save()
                } else {
                    this.shouldDisplaySave = false
                    document.getSelection().removeAllRanges()
                }
            })
        },
        setValue(value) {
            this.convertedValue = value
            this.shouldDisplaySave = false
            this.bodyOpened = false
            this.$emit('input', value)
            document.getSelection().removeAllRanges()
        },
        setMenu(top, left) {
            let largestHeight = 0
            let largestWidth = 0

            if (this.$refs.menu) {
                largestHeight =
                    window.innerHeight - this.$refs.menu.offsetHeight - 25
                largestWidth =
                    window.innerWidth - this.$refs.menu.offsetWidth - 25
            }

            if (top > largestHeight) {
                top = largestHeight
            }
            if (left > largestWidth) {
                left = largestWidth
            }
            this.top = `${top + 20}px`
            this.left = `${left}px`
            let rowHeight =
                document.getElementsByClassName('menu-row')[1].clientHeight
            this.$refs.menu.scrollTo(
                0,
                rowHeight * (this.value / 30) - this.$refs.menu.offsetHeight / 2
            )
        },
        openBody($event) {
            if (this.bodyOpened) {
                return
            }
            this.bodyOpened = true
            this.$nextTick(() => {
                this.$refs.hours.focus()
                this.$refs.hours.select()
                this.setMenu($event.clientY, $event.clientX)
            })
            $event.preventDefault()
        },
        save() {
            this.shouldDisplaySave = false
            const hours =
                this.inputHours != '-' ? parseInt(this.inputHours) * 60 : 0
            const minutes =
                this.inputMinutes != '-' ? parseInt(this.inputMinutes) : 0
            this.$emit('input', hours + minutes)
            document.getSelection().removeAllRanges()
        },
        numberTotwoCharacterString(value) {
            if (value < 10) {
                return `0${value}`
            } else {
                return value.toString()
            }
        },
        setMinutes() {
            let seconds = this.convertedValue * 60
            let hours = Math.floor(seconds / 3600)
            let minutes = Math.floor((seconds - hours * 3600) / 60)
            if (this.convertedValue == -1 || !this.convertedValue) {
                this.inputMinutes = '00'
            } else {
                this.inputMinutes = this.numberTotwoCharacterString(minutes)
            }
            this.oldInputMinutes = this.inputMinutes
        },
        setHours() {
            let seconds = this.convertedValue * 60
            let hours = Math.floor(seconds / 3600)
            if (this.convertedValue == -1 || !this.convertedValue) {
                this.inputHours = '00'
            } else {
                this.inputHours = this.numberTotwoCharacterString(hours)
            }
            this.oldInputHours = this.inputHours
        },
        selectValue(type) {
            if (this.shouldDisableInput) {
                return
            }
            this.$nextTick(() => {
                if (type == 'minutes') {
                    this.$refs.minutes.select()
                }
                if (type == 'hours') {
                    this.$refs.hours.select()
                }
            })
        },
        onMinutes($event) {
            let minutes = Number($event.target.value)
            if (isNaN(minutes)) {
                minutes = '00'
            }
            if (minutes > 59) {
                minutes = '59'
            }
            if (minutes == 0) {
                minutes == '00'
            }
            this.inputMinutes = minutes
            this.$forceUpdate()
        },
        onHours($event) {
            let hours = Number($event.target.value)
            if (isNaN(hours)) {
                hours = '00'
            }
            if (hours > 23) {
                hours = '23'
            }
            this.inputHours = hours
        }
    },
    watch: {
        convertedValue() {
            this.setHours()
            this.setMinutes()
        },
        value() {
            this.convertedValue = this.value
            this.setHours()
            this.setMinutes()
        }
    },
    mounted() {
        this.convertedValue = this.value
        this.setHours()
        this.setMinutes()
    }
}
</script>
<style lang="scss" scoped>
.section-selector {
    display: flex;
    align-items: center;
}
.input-row {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    font-size: 1.1rem;
    background-color: transparent;
    border-radius: $input-radius;
    transition: $ease;

    &.-body-opened {
        z-index: $high;
    }

    &:hover {
        transform: translateY(0.1rem);
    }
}
.time-input input {
    max-width: 5rem;
    text-align: center;
    background: none;
    border: none;
    outline: none;
    font-family: $input-family;
    font-size: 1.1rem;
    padding: 0;

    &::-moz-selection {
        background-color: $main-accent;
        color: $background;
    }
    &::selection {
        background-color: $main-accent;
        color: $background;
    }
}
.divider {
    padding: 0 1rem;
}
.column-button img {
    height: 0.8rem;
    margin-right: 0.6rem;
    margin-top: 0.4rem;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: scale(1.2);
    }
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.column-button {
    transition: 0.3s ease all;

    &.-hidden {
        pointer-events: none;
        width: 0px;
    }
}
.input-icon {
    transition: 0.3s ease all;
    opacity: 1;

    &.-hidden {
        pointer-events: none;
        opacity: 0;
    }
}
.menu-body {
    position: fixed;
    padding: 12px 0;
    background: #fff;
    box-shadow: $object-shadow;
    border-radius: 8px;
    z-index: $highest;
    outline: none;
    color: $input;
    max-height: 15%;

    overflow-y: auto;

    &.-bigger-text {
        max-height: 30%;
    }
}
.menu-row {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    transition: 0.2s ease all;
    cursor: pointer;
    font-family: $input-family;

    &.-selected {
        background: rgb(236, 236, 236) !important;
    }

    &.-bigger-text {
        font-size: 1.5rem;
    }

    &:hover {
        background: rgb(236, 236, 236) !important;
    }
}
.opener {
    position: absolute;
    width: 100%;
    height: 100%;
}
.-error {
    color: $accent-red;
}
</style>
